<script setup lang="ts">
const queryClient = useQueryClient();
await queryClient.ensureQueryData(productsQueryOptions({ slugs: ['trailer'] }));
const { getBySlug } = useProducts({ slugs: ['trailer'] });
const product = computed(() => getBySlug('trailer'));
useSeo({ title: computed(() => product.value?.heading?.value ?? '') });

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: 'Forside', item: '/' },
      { name: 'Kørekort', item: '/kørekort' },
      { name: computed(() => product.value?.heading?.value ?? 'Trailer') },
    ],
  }),
  defineCourse({
    name: computed(() => product.value?.heading?.value ?? ''),
    description: computed(() => product.value?.description?.value ? stripHtml(product.value.description.value) : ''),
    inLanguage: 'da',
    provider: { '@id': '#identity' },
  }),
]);
</script>

<template>
  <ProductContainer
    v-if="product"
    :product="product.product"
  >
    <template #illustration>
      <IconsCategoryTrailer />
    </template>
    <LazyVisibleContactForm
      subject="Tilmelding - BE"
      is-signup
      hydrate-on-visible
    />
  </ProductContainer>
</template>
